<template>
  <div class="settings-sidebar sidebar">
    <vue-scroll :ops="ops">
      <div class="settings-section">
        <span class="section-title">{{ label.get("profile") }}</span>
        <ul class="profile">
          <li>
            <router-link :to="{ path: '/settings/profile' }" tag="a">
              <i class="atto atto-user-avatar setting-icon" />
              <span class="section-label">{{
                label.get("profile_password")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/notifications' }" tag="a">
              <i class="atto atto-notifications setting-icon" />
              <span class="section-label">{{
                label.get("notifications_reminders")
              }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div
        v-if="canAccessCompany || canAccessManageTeam"
        class="settings-section"
      >
        <span class="section-title">{{ label.get("account") }}</span>
        <ul class="profile">
          <li v-if="canAccessManageTeam">
            <router-link
              v-if="owner"
              :to="{ path: '/settings/company' }"
              tag="a"
            >
              <i class="atto atto-current-firm setting-icon" />
              <span class="section-label">{{ company_name }}</span>
            </router-link>
            <span v-if="!owner">
              <i class="atto atto-current-firm setting-icon" />
              <span class="section-label">{{ company_name }}</span>
            </span>
          </li>
          <li v-if="canAccessManageTeam">
            <router-link :to="{ path: '/settings/manage-team' }" tag="a">
              <i class="atto atto-team setting-icon" />
              <span class="section-label">{{ label.get("manage_team") }}</span>
            </router-link>
          </li>
          <li v-if="canAccessInviteMembers">
            <a href="javascript:void(0)" @click="inviteMember">
              <i class="atto atto-add-more setting-icon" />
              <span class="section-label">{{
                label.get("invite_new_members")
              }}</span>
            </a>
          </li>
          <li v-if="canAccessBilling">
            <a :href="onDashboardRedirections" target="_blank">
              <i class="atto atto-subscription-card setting-icon" />
              <span class="section-label">{{ label.get("subscription") }}</span>
            </a>
          </li>
          <li v-if="canAccessCompany">
            <router-link :to="{ path: '/settings/integrations' }" tag="a">
              <i class="atto atto-integrations setting-icon" />
              <span class="section-label">{{ label.get("integrations") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="canAccessCompany" class="settings-section">
        <span class="section-title">{{ label.get("company_settings") }}</span>
        <ul class="company-settings">
          <li>
            <router-link :to="{ path: '/settings/time-clock' }" tag="a">
              <i class="atto atto-web-time-clock setting-icon" />
              <span class="section-label">{{
                label.get("web_time_clock")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/departments' }" tag="a">
              <i class="atto atto-departments setting-icon" />
              <span class="section-label">{{ label.get("departments") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/workweek-overtime' }" tag="a">
              <i class="atto atto-calendar-icon setting-icon" />
              <span class="section-label">{{
                label.get("workweek_overtime")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/timesheet-report' }" tag="a">
              <i class="atto atto-timesheet-reports setting-icon" />
              <span class="section-label">{{
                label.get("timesheet_report")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/manual-entries' }" tag="a">
              <i class="atto atto-manual-entry setting-icon" />
              <span class="section-label">{{
                label.get("manual_entries")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/time-options' }" tag="a">
              <i class="atto atto-time-options setting-icon" />
              <span class="section-label">
                {{ label.get("time_options") }}
              </span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/break-preferences' }" tag="a">
              <i class="atto atto-break setting-icon" />
              <span class="section-label">
                {{ label.get("break_preferences") }}
              </span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/job-codes' }" tag="a">
              <i class="atto atto-jobs setting-icon" />
              <span class="section-label">{{ label.get("job_codes") }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/pto' }" tag="a">
              <i class="atto atto-pto setting-icon" />
              <span class="section-label">
                {{ label.get("time_off_settings") }}
              </span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/location-tracking' }" tag="a">
              <i class="atto atto-location-marker setting-icon" />
              <span class="section-label">{{
                label.get("location_tracking")
              }}</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/settings/job-sites' }" tag="a">
              <i class="atto atto-favorite-location setting-icon" />
              <span class="section-label">{{ label.get("job_sites") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="isComingFromDashboard" class="settings-section">
        <span class="section-title">{{ label.get("support") }}</span>
        <ul class="support-settings">
          <li>
            <a href="https://help.attotime.com" target="_blank">
              <i class="atto atto-help-service setting-icon" />
              <span class="section-label">{{ label.get("help_center") }}</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="feedbackAndSupport">
              <i class="atto atto-help-support support setting-icon" />
              <span class="section-label">{{
                label.get("feedback_support")
              }}</span>
            </a>
          </li>
        </ul>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import AuthService from "../../../shared/services/AuthService";

export default {
  name: "SettingsSidebarComponent",
  data() {
    return {
      accessToken: AuthService.getToken(),
      hostname: window.location.hostname,
      company_name: this.$store.state.company.name,
      owner: this.$store.state.user.is_owner,
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: false,
          keepShow: false,
          background: "#c1c1c1",
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0,
          size: "6px",
          disable: false,
        },
      },
    };
  },
  computed: {
    isComingFromDashboard() {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const isTokenParam = params.get("token");

      if (!!isTokenParam) {
        return false;
      } else {
        return true;
      }
    },
    canAccessBilling() {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const isTokenParam = params.get("token");

      if (!!isTokenParam) {
        return false;
      } else {
        return this.$store.state.permission.canAccessBilling;
      }
    },
    canAccessManageTeam() {
      return this.$store.state.permission.canAccessManageTeam;
    },
    canAccessInviteMembers() {
      return this.$store.state.permission.canAccessManageTeam;
    },
    canAccessCompany() {
      return this.$store.state.permission.canAccessSettings;
    },
    onDashboardRedirections() {
      return this.hostname.includes("spectalabs.dev")
        ? `https://dashboard.atto.spectalabs.dev/subscription/management?token=${this.accessToken}`
        : `https://dashboard.attotime.com/subscription/management?token=${this.accessToken}`;
    },
  },
  methods: {
    inviteMember: function () {
      this.$root.$emit("showInviteMembers");
    },
    feedbackAndSupport() {
      this.$root.$emit("showFeedbackModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-sidebar {
  top: 87px;
  height: calc(100vh - 87px);

  .settings-section {
    display: flex;
    flex-direction: column;

    .section-title {
      display: inline-flex;
      padding: 18px 64px 4px;
      font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
      color: $atto-not-active;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;

    li {
      > span {
        display: flex;
        flex-direction: row;
        padding: 8px 11px 8px 22px;
        box-sizing: border-box;
        @include base-transition(ease background-color 0.2s);

        i.setting-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          margin-right: 18px;

          &:before {
            font-size: 17px;
            color: $atto-dark-grey;
          }
        }

        span.section-label {
          display: inline-flex;
          flex-grow: 1;
          font-size: 0.9375rem;
          line-height: 1.5rem;
          font-family: "Roboto", sans-serif;
          color: #262626;
          font-weight: 400;
        }
      }

      a {
        display: flex;
        flex-direction: row;
        padding: 8px 11px 8px 22px;
        box-sizing: border-box;
        @include base-transition(ease background-color 0.2s);

        i.setting-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          margin-right: 18px;

          &:before {
            font-size: 16px;
            color: $atto-dark-grey;
          }

          &.atto-help-service {
            background-image: url("../../../../images/help-center-icon.svg");
            -webkit-background-size: 19px;
            background-size: 19px;
            background-repeat: no-repeat;
            background-position: center;
          }
          &.atto-web-time-clock {
            background-image: url("../../../../images/atto-web-time-clock-icon.svg");
            -webkit-background-size: 19px;
            background-size: 19px;
            background-repeat: no-repeat;
            background-position: center;
          }
          &.atto-time-options {
            background-image: url("../../../../images/atto-time-options-icon.svg");
            -webkit-background-size: 19px;
            background-size: 19px;
            background-repeat: no-repeat;
            background-position: center;
          }

          &.atto-notifications,
          &.atto-calendar-icon {
            &:before {
              font-size: 19px;
            }
          }
          &.atto-current-firm {
            &:before {
              font-size: 15px;
            }
          }
          &.atto-subscription-card {
            &:before {
              font-size: 14px;
            }
          }
          &.atto-manual-entry {
            &:before {
              font-size: 12px;
            }
          }
          &.atto-total-hours,
          &.atto-favorite-location,
          .atto-jobs,
          &.atto-departments {
            &:before {
              font-size: 18px;
            }
          }
          &.atto-break,
          &.atto-pto {
            &:before {
              font-size: 20px;
            }
          }
        }

        span.section-label {
          display: inline-flex;
          flex-grow: 1;
          font-size: 0.9375rem;
          line-height: 1.5rem;
          font-family: $roboto-font;
          color: $atto-font-color;
          font-weight: 400;
        }

        div.arrow {
          display: flex;
          width: 24px;
          height: 24px;
          justify-content: center;
          align-items: center;

          i {
            color: $atto-dark-grey;
            font-size: 0.75rem;
          }
        }

        &.router-link-active {
          position: relative;
          z-index: 2;
          padding-top: 8px;
          padding-bottom: 8px;
          /*margin-top: -1px;
          margin-bottom: -1px;*/

          i.setting-icon {
            &:before {
              color: $atto-font-color;
            }
            &.atto-web-time-clock {
              background-image: url("../../../../images/atto-web-time-clock-icon-dark.svg");
            }
            &.atto-time-options {
              background-image: url("../../../../images/atto-time-options-icon-dark.svg");
            }
          }

          span.section-label {
            font-weight: 500;
          }
        }

        &:hover {
          /* background-color: $atto-grey;*/
          i.setting-icon {
            &:before {
              color: $atto-font-color;
            }
            &.atto-help-service {
              background-image: url("../../../../images/help-center-icon-dark.svg");
            }
            &.atto-web-time-clock {
              background-image: url("../../../../images/atto-web-time-clock-icon-dark.svg");
            }
            &.atto-time-options {
              background-image: url("../../../../images/atto-time-options-icon-dark.svg");
            }
          }

          span.section-label {
            font-weight: 500;
          }
        }
      }

      .new-link {
        display: flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;

        i {
          display: inline-flex;
          width: 24px;
          height: 24px;
          background-image: url("../../../../images/new-tab-icon.svg");
          -webkit-background-size: 15px;
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    &.support-settings {
      margin-bottom: 26px;
    }
  }
}

.trial-not-expired .settings-sidebar {
  top: 135px;
  height: calc(100vh - 135px);
}

.atto-integrations {
  &:before {
    content: "";
    background: url("~@assets/images/integrations-icon.svg") no-repeat;
    display: flex;
    width: 24px;
    height: 24px;
    background-size: 22px;
  }
}

@media (max-width: 1024px) {
  .settings-sidebar {
    display: none;
  }
}
</style>

<style lang="scss">
.settings-sidebar {
  ul {
    z-index: 0;
  }
  .ps {
    max-height: calc(100vh - 73px);
    padding: 14px 0 40px;

    .ps__rail-y {
      width: 16px;
      opacity: 0;
      z-index: 2;

      &:hover {
        background-color: transparent;

        .ps__thumb-y {
          width: 8px;
          background-color: rgba(239, 239, 239, 1);
        }
      }

      &.ps--clicking {
        background-color: transparent;
      }
    }

    .ps__thumb-y {
      right: 4px;
      width: 8px;
      opacity: 1;
      background-color: rgba(239, 239, 239, 0.5);
    }

    &:hover {
      .ps__rail-y {
        opacity: 1;
      }
    }
  }
  .__bar-wrap-is-vertical {
    right: 4px;
    .__bar-is-vertical {
      background: hsla(0, 0%, 93.7%, 0.5) !important;
      width: 8px !important;
      border-radius: 6px;
    }
  }
}
</style>
